export default {
  path: '/shopbuzz',
  name: 'shopbuzz',
  component: () => import('@/modules/shopbuzz/pages/Entry.vue'),
  meta: {
    metaTags: [
      {
        name: 'description',
        content: 'ShopBuzz - Competitive intelligence built for e-commerce. Track competitors, discover opportunities, and stay on top of your shop\'s performance.',
      },
      {
        page_slug: 'shopbuzz',
      },
    ],
    title: 'eRank — ShopBuzz',
  },
};
